import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "pluralTranslate",
  pure: false,
  standalone: true,
})
export class PluralTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(key: string, count: number, params: Record<string, unknown> = {}, pluralSuffix = "_plural"): string {
    const finalKey = count === 1 ? key : `${key}${pluralSuffix}`;

    return this.translateService.instant(finalKey, {
      ...params,
      count,
    });
  }
}
